import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios';
import { withError, withInvalidate } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';
import { buildUrl } from '@/react/portainer/environments/environment.service/utils';
import { environmentQueryKeys } from '@/react/portainer/environments/queries/query-keys';

interface UpdateAccessPayload {
  id: EnvironmentId;
  userAccessPolicies: Record<number, { RoleId: number }>;
  teamAccessPolicies: Record<number, { RoleId: number }>;
}

export function useUpdateEnvironmentAccess() {
  const queryClient = useQueryClient();

  return useMutation(updateAccess, {
    ...withInvalidate(queryClient, [environmentQueryKeys.base()]),
    ...withError('Unable to update environment access'),
  });
}

async function updateAccess({
  id,
  userAccessPolicies,
  teamAccessPolicies,
}: UpdateAccessPayload) {
  try {
    const { data } = await axios.put(buildUrl(id), {
      UserAccessPolicies: userAccessPolicies,
      TeamAccessPolicies: teamAccessPolicies,
    });
    return data;
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to update environment access');
  }
}
